import useAutoFetch from "v4/hooks/useAutoFetch";
import {generateUrl} from "v4/services/api.service";
import useFetch from "v4/hooks/useFetch";
import {RESET_PASSWORD_CHANGE, RESET_PASSWORD_CHANGE_FORM} from "v4/data/apiRoutes";
import {useEffect} from "react";
import useNotification from "v4/hooks/useNotification";
import {useHistory} from "react-router-dom";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import {routesBase} from "v4/data/appRoutes";
import jsonToFormData from "v4/utils/jsonToFormData";

export default function useResetPasswordChange(userId, token) {
    const {t} = usePolTranslation();
    const {addSuccessNotification} = useNotification();
    const {data} = useAutoFetch(generateUrl(RESET_PASSWORD_CHANGE_FORM, {userId, token}), null, {notoken: true});
    const form = data?.['hydra:member'];

    const [{data: saveData, isLoading: isSaveLoading, errorData}, saveFetch] = useFetch();

    const onSubmit = (data) => {
        saveFetch({
            url: generateUrl(RESET_PASSWORD_CHANGE),
            config: {
                method: 'POST',
                body: jsonToFormData(data),
                notoken: true,
            }
        })
    }

    const {replace} = useHistory();
    useEffect(() => {
        if (!saveData?.successes) return;

        saveData.successes.forEach(message => addSuccessNotification(t(message)));
        replace(routesBase.baseLogin)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saveData]);

    return {
        form,
        onSubmit,
        isSaveLoading,
        formErrors: errorData?.errors,
        errorMessages: errorData?.errors?.['_form']?.messages,
    }
}
